// Routes Configuration
export const globalRoutes = Object.freeze({
  home: "/", 
  terms:'/terms-conditions',
  refund:'/booking-refund',
  privacy:'/privacy-policy' 
});